import { render, staticRenderFns } from "./FavoriteCard.vue?vue&type=template&id=0139d084&scoped=true"
import script from "./FavoriteCard.vue?vue&type=script&lang=js"
export * from "./FavoriteCard.vue?vue&type=script&lang=js"
import style0 from "./FavoriteCard.vue?vue&type=style&index=0&id=0139d084&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139d084",
  null
  
)

export default component.exports